import React from 'react';

import { classNames } from '@/helpers/classNames';
import { SvgIcon } from '@material-ui/core';

import { default as hand } from './hand.svg?react';
import styles from './SwipeUpScreen.module.scss';

type SwipeUpScreenProps = {
	className?: string;
	onClick?: () => void;
};

export const SwipeUpScreen: React.FC<SwipeUpScreenProps> = ({
	className,
	onClick = () => {},
}) => {
	const classes = classNames([styles['root'], className]);

	return (
		<div className={classes} onClick={onClick}>
			<div className={styles['hand']}>
				<SvgIcon component={hand} viewBox="0 0 32 46" />
				<div className={styles['text']}>Swipe up</div>
			</div>
		</div>
	);
};
